import React, { Component } from 'react'
import { Redirect } from 'react-router-dom'
import { FormattedMessage, injectIntl } from 'react-intl'
import {
    Table,
    TableContainer,
    TableHead,
    TableRow,
    TableBody,
    CircularProgress,
} from '@material-ui/core'
import TablePagination from '@material-ui/core/TablePagination'
import Select from 'react-select'
import { StyledTableCell } from '../../commons/utils/TableStyles.js'
import AjaxHandler from '../../commons/ajax/AjaxHandler.js'
import LocaleFormat from '../../commons/utils/LocaleFormat.js'
import Security from '../../commons/security/Security.js'
import ConfigBusiness from '../../commons/config/ConfigBusiness.js'
import PresupuestoColorLegenda from './PresupuestoColorLegenda.jsx'
import PeriodoPresupuestarioImportar from './PeriodoPresupuestarioImportar.jsx'

const KPI_CONFIG = [
    { key: 'asignado',     colorClass: 'success', icon: 'la la-dollar',       labelId: 'periodoPresupuestario.kpi.asignado',     labelDefault: 'Presupuesto asignado' },
    { key: 'distribuido',  colorClass: 'primary', icon: 'la la-share-alt',    labelId: 'periodoPresupuestario.kpi.distribuido',  labelDefault: 'Distribuido' },
    { key: 'comprometido', colorClass: 'warning', icon: 'fa fa-clock-o',      labelId: 'periodoPresupuestario.kpi.comprometido', labelDefault: 'Comprometido' },
    { key: 'consumido',    colorClass: 'danger',  icon: 'fa fa-check-circle', labelId: 'periodoPresupuestario.kpi.consumido',    labelDefault: 'Consumido' },
]

class PeriodoPresupuestarioSubregiones extends Component {
    constructor(props) {
        super(props)
        this.ajaxHandler = new AjaxHandler()
        this.state = {
            totales:             { asignado: 0, distribuido: 0, comprometido: 0, consumido: 0 },
            subregiones:         [],
            loading:             false,
            periodoId:           null,
            periodos:            [],
            redirectTo:          null,
            selectedSubregiones: [],
            page:                0,
            rowsPerPage:         10,
            periodoActivo:       null,
            porcentaje:          ConfigBusiness.get('periodoPresupuestario.porcentajeCorte'),
            modalImportar:       false,
        }
    }

    componentWillMount() {
        if (Security.hasPermission('PERIODO_PRESUPUESTARIO_SUBREGIONES_VER')) {
            this.ajaxHandler.subscribe(this)
            this.loadData(this.state.periodoId)
            this.ajaxHandler.getJson('/presupuestos/periodo-activo')
                .then(function(periodo) { this.setState({ periodoActivo: periodo || null }) }.bind(this))
            this.ajaxHandler.getJson('/presupuestos/periodos-select')
                .then(function(data) { this.setState({ periodos: data || [] }) }.bind(this))
        } else {
            this.setState({ redirectTo: '/error' })
        }
    }

    componentWillUnmount() {
        this.ajaxHandler.unsubscribe()
    }

    loadData(periodoId) {
        this.setState({ loading: true, page: 0 })
        var url = '/presupuestos/resumen-subregiones' + (periodoId !== null ? '?periodoId=' + periodoId : '')
        this.ajaxHandler.getJson(url)
            .then(data => {
                if (data) {
                    var totales     = Object.assign({}, data.totales, { restante: data.totales.asignado - data.totales.distribuido })
                    var subregiones = data.subregiones.map(function(s) { return Object.assign({}, s, { restante: s.asignado - s.distribuido }) })
                    this.setState({ totales, subregiones })
                }
            })
            .finally(() => this.setState({ loading: false }))
    }

    handleExportar() {
        var periodoId           = this.state.periodoId
        var selectedSubregiones = this.state.selectedSubregiones
        var params = []
        if (periodoId !== null) params.push('periodoId=' + periodoId)
        if (selectedSubregiones && selectedSubregiones.length > 0) {
            selectedSubregiones.forEach(function(s) { params.push('subregionIds[]=' + s.value) })
        }
        var url = '/presupuestos/subregiones/exportar-excel' + (params.length > 0 ? '?' + params.join('&') : '')
        this.ajaxHandler.fetch(url, { method: 'GET' })
            .then(function(response) {
                if (response.status === 200) { return response.blob() }
                return null
            })
            .then(function(blob) {
                if (!blob) return
                var blobUrl = URL.createObjectURL(blob)
                var a = document.createElement('a')
                a.href = blobUrl
                a.download = 'presupuesto-subregiones.xlsx'
                document.body.appendChild(a)
                a.click()
                document.body.removeChild(a)
                URL.revokeObjectURL(blobUrl)
            })
            .catch(function() {})
    }

    formatCurrency(value) {
        return new Intl.NumberFormat(LocaleFormat.getNumberLocale(), { style: 'currency', currency: 'ARS' }).format(value || 0)
    }

    getIconColor(disponible, asignado) {
        if (asignado === 0 && disponible === 0) return 'gray'
        const pct = (disponible / asignado) * 100
        if (pct === 100) return '#474789'
        if (pct >= this.state.porcentaje) return '#28D094'
        if (pct > 0) return '#F1EA7F'
        return '#FF4961'
    }

    calcPct(value, base) {
        if (!base || base === 0) return 0
        return Math.min(100, Math.round((value / base) * 100))
    }

    kpiSubtitle(key, t) {
        var periodoId = this.state.periodoId
        var periodos  = this.state.periodos
        var intl = this.props.intl
        if (key === 'asignado') {
            if (periodoId === null) return intl.formatMessage({ id: 'periodoPresupuestario.toggle.todos', defaultMessage: 'Todos los períodos' })
            var p = periodos.find(function(x) { return x.id === periodoId })
            return p ? p.nombre : intl.formatMessage({ id: 'periodoPresupuestario.toggle.todos', defaultMessage: 'Todos los períodos' })
        }
        if (key === 'distribuido')  return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.distribuido', defaultMessage: '{pct}% del total' }, { pct: this.calcPct(t.distribuido, t.asignado) })
        if (key === 'comprometido') return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.comprometido', defaultMessage: 'Tickets aprobados' })
        if (key === 'consumido')    return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.consumido', defaultMessage: 'Tickets cerrados' })
        if (key === 'restante')     return intl.formatMessage({ id: 'periodoPresupuestario.kpi.subtitle.distribuido', defaultMessage: '{pct}% del total' }, { pct: this.calcPct(t.restante, t.asignado) })
        return ''
    }

    getFilteredSubregiones() {
        var subregiones         = this.state.subregiones
        var selectedSubregiones = this.state.selectedSubregiones
        if (!selectedSubregiones || selectedSubregiones.length === 0) return subregiones
        var selectedIds = selectedSubregiones.map(function(o) { return o.value })
        return subregiones.filter(function(s) { return selectedIds.indexOf(s.id) !== -1 })
    }

    render() {
        var totales             = this.state.totales
        var loading             = this.state.loading
        var periodoId           = this.state.periodoId
        var periodos            = this.state.periodos
        var redirectTo          = this.state.redirectTo
        var selectedSubregiones = this.state.selectedSubregiones
        var page                = this.state.page
        var rowsPerPage         = this.state.rowsPerPage
        var periodoActivo       = this.state.periodoActivo
        var modalImportar       = this.state.modalImportar

        if (redirectTo) return <Redirect push to={redirectTo} />

        var filtered  = this.getFilteredSubregiones()
        var paginated = filtered.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        var effectiveTotales = selectedSubregiones && selectedSubregiones.length > 0
            ? filtered.reduce(function(acc, s) {
                return {
                    asignado:     acc.asignado     + s.asignado,
                    distribuido:  acc.distribuido  + s.distribuido,
                    comprometido: acc.comprometido + s.comprometido,
                    consumido:    acc.consumido    + s.consumido,
                    restante:     acc.restante     + s.restante,
                }
            }, { asignado: 0, distribuido: 0, comprometido: 0, consumido: 0, restante: 0 })
            : totales

        return (
            <React.Fragment>
                <PeriodoPresupuestarioImportar
                    open={modalImportar}
                    modulo="subregiones"
                    onClose={() => this.setState({ modalImportar: false })}
                    onImportSuccess={() => { this.setState({ modalImportar: false }); this.loadData(periodoId) }}
                />
                {/* Badge período seleccionado */}
                <div className="row mb-1">
                    <div className="col-12">
                        {periodoId === null ? (
                            <span>
                                <span className="text-muted mr-1" style={{ fontSize: '0.85rem' }}>
                                    <FormattedMessage id="periodoPresupuestario.toggle.todos" defaultMessage="Todos los períodos" />
                                </span>
                                {periodoActivo && (
                                    <span className="badge badge-primary" style={{ fontSize: '0.85rem', padding: '6px 10px' }}>
                                        {periodoActivo.config_fecha_inicio} — {periodoActivo.config_fecha_fin}
                                    </span>
                                )}
                            </span>
                        ) : (function() {
                            var p = periodos.find(function(x) { return x.id === periodoId })
                            return p ? (
                                <span>
                                    <span className="text-muted mr-1" style={{ fontSize: '0.85rem' }}>
                                        <FormattedMessage id="periodoPresupuestario.badge.periodo_actual" defaultMessage="Período actual" />
                                    </span>
                                    <span className="badge badge-success" style={{ fontSize: '0.85rem', padding: '6px 10px' }}>
                                        {p.nombre} - {p.fecha_inicio} — {p.fecha_fin}
                                    </span>
                                </span>
                            ) : null
                        }.bind(this))()}
                    </div>
                </div>

                {/* KPI Cards */}
                <div className="row">
                    {KPI_CONFIG.map(kpi => (
                        <div key={kpi.key} className="col-xl-3 col-lg-6 col-12">
                            <div className="card pull-up">
                                <div className="card-content">
                                    <div className="card-body">
                                        <div className="media d-flex">
                                            <div className="media-body text-left">
                                                <h3 className={'text-' + kpi.colorClass + ' font-weight-500'}>
                                                    {loading ? <CircularProgress size={22} /> : this.formatCurrency(effectiveTotales[kpi.key])}
                                                </h3>
                                                <h6>
                                                    <FormattedMessage id={kpi.labelId} defaultMessage={kpi.labelDefault} />
                                                </h6>
                                                <small className="text-muted">{this.kpiSubtitle(kpi.key, effectiveTotales)}</small>
                                            </div>
                                            <div>
                                                <i className={kpi.icon + ' text-' + kpi.colorClass + ' font-large-2 float-right'}></i>
                                            </div>
                                        </div>
                                        <div className="progress progress-sm mt-1 mb-0 box-shadow-2">
                                            <div
                                                className={'progress-bar bg-gradient-x-' + kpi.colorClass}
                                                role="progressbar"
                                                style={{ width: this.calcPct(effectiveTotales[kpi.key], effectiveTotales.asignado) + '%' }}
                                            ></div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Grid */}
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-content collapse show">
                                <div className="card-body card-dashboard">
                                    {/* Filters */}
                                    <div className="d-flex align-items-center flex-wrap mb-1">
                                        <div style={{ minWidth: '200px', flexGrow: 1, maxWidth: '320px' }} className="mr-2">
                                            <Select
                                                multi={true}
                                                placeholder={this.props.intl.formatMessage({ id: 'periodoPresupuestario.filtro.subregion', defaultMessage: 'Filtrar por subregión...' })}
                                                options={this.state.subregiones.map(function(s) { return { value: s.id, label: s.nombre } })}
                                                value={selectedSubregiones}
                                                onChange={selected => this.setState({ selectedSubregiones: selected || [], page: 0 })}
                                            />
                                        </div>
                                        <div style={{ minWidth: '220px' }} className="mr-2">
                                            <Select
                                                className="select-periodo-pp"
                                                clearable={false}
                                                value={
                                                    periodoId === null
                                                        ? { value: '__todos__', label: this.props.intl.formatMessage({ id: 'periodoPresupuestario.toggle.todos', defaultMessage: 'Todos los períodos' }) }
                                                        : (periodos.map(function(p) { return { value: p.id, label: p.nombre + ' (' + p.fecha_inicio + ' — ' + p.fecha_fin + ')' } }).find(function(o) { return o.value === periodoId }) || null)
                                                }
                                                options={[
                                                    { value: '__todos__', label: this.props.intl.formatMessage({ id: 'periodoPresupuestario.toggle.todos', defaultMessage: 'Todos los períodos' }) }
                                                ].concat(periodos.map(function(p) { return { value: p.id, label: p.nombre + ' (' + p.fecha_inicio + ' — ' + p.fecha_fin + ')' } }))}
                                                onChange={function(selected) {
                                                    var newId = selected && selected.value !== '__todos__' ? selected.value : null
                                                    this.setState({ periodoId: newId })
                                                    this.loadData(newId)
                                                }.bind(this)}
                                                disabled={loading}
                                                placeholder={this.props.intl.formatMessage({ id: 'periodoPresupuestario.toggle.todos', defaultMessage: 'Todos los períodos' })}
                                            />
                                        </div>
                                        <div className="dt-buttons btn-group">
                                            {Security.hasPermission('PERIODO_PRESUPUESTARIO_SUBREGIONES_VER') && (
                                                <button type="button" className="btn btn-secondary buttons-collection" onClick={() => this.handleExportar()} title={this.props.intl.formatMessage({ id: 'periodoPresupuestario.exportar.tooltip', defaultMessage: 'Exportar Excel' })}>
                                                    <i className="ft-upload"></i>
                                                </button>
                                            )}
                                            {Security.hasPermission('PERIODO_PRESUPUESTARIO_SUBREGIONES_MODIFICAR') && (
                                                <button type="button" className="btn btn-secondary buttons-collection" onClick={() => this.setState({ modalImportar: true })} title={this.props.intl.formatMessage({ id: 'periodoPresupuestario.importar.tooltip', defaultMessage: 'Importar Excel' })}>
                                                    <i className="ft-download"></i>
                                                </button>
                                            )}
                                        </div>
                                        <div className="ml-auto">
                                            <PresupuestoColorLegenda />
                                        </div>
                                    </div>

                                    <TableContainer>
                                        <Table aria-label="subregiones-presupuesto" className="table-hover">
                                            <TableHead>
                                                <TableRow>
                                                    <StyledTableCell style={{ width: '30px' }}></StyledTableCell>
                                                    <StyledTableCell><FormattedMessage id="periodoPresupuestario.grid.subregion" defaultMessage="Subregión" /></StyledTableCell>
                                                    <StyledTableCell align="right"><FormattedMessage id="periodoPresupuestario.kpi.asignado" defaultMessage="Asignado" /></StyledTableCell>
                                                    <StyledTableCell align="right"><FormattedMessage id="periodoPresupuestario.kpi.distribuido" defaultMessage="Distribuido" /></StyledTableCell>
                                                    <StyledTableCell align="right"><FormattedMessage id="periodoPresupuestario.kpi.comprometido" defaultMessage="Comprometido" /></StyledTableCell>
                                                    <StyledTableCell align="right"><FormattedMessage id="periodoPresupuestario.kpi.consumido" defaultMessage="Consumido" /></StyledTableCell>
                                                    <StyledTableCell align="right"><FormattedMessage id="periodoPresupuestario.kpi.restante" defaultMessage="Restante" /></StyledTableCell>
                                                    <StyledTableCell align="center"><FormattedMessage id="periodoPresupuestario.grid.acciones" defaultMessage="Acciones" /></StyledTableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {loading && (
                                                    <TableRow>
                                                        <StyledTableCell colSpan={8} align="center">
                                                            <CircularProgress />
                                                        </StyledTableCell>
                                                    </TableRow>
                                                )}
                                                {!loading && filtered.length === 0 && (
                                                    <TableRow>
                                                        <StyledTableCell colSpan={8} align="center">
                                                            <FormattedMessage id="periodoPresupuestario.grid.sin_datos" defaultMessage="Sin datos para el período seleccionado" />
                                                        </StyledTableCell>
                                                    </TableRow>
                                                )}
                                                {!loading && paginated.map(subregion => (
                                                    <TableRow key={subregion.id}>
                                                        <StyledTableCell>
                                                            <i className="fa fa-circle" style={{ color: this.getIconColor(subregion.restante, subregion.asignado), fontSize: '1.2rem' }} title={'Restante:' + this.formatCurrency(subregion.restante)}></i>
                                                        </StyledTableCell>
                                                        <StyledTableCell>{subregion.nombre}</StyledTableCell>
                                                        <StyledTableCell align="right">{this.formatCurrency(subregion.asignado)}</StyledTableCell>
                                                        <StyledTableCell align="right">{this.formatCurrency(subregion.distribuido)}</StyledTableCell>
                                                        <StyledTableCell align="right">{this.formatCurrency(subregion.comprometido)}</StyledTableCell>
                                                        <StyledTableCell align="right">{this.formatCurrency(subregion.consumido)}</StyledTableCell>
                                                        <StyledTableCell align="right">{this.formatCurrency(subregion.restante)}</StyledTableCell>
                                                        <StyledTableCell align="center" style={{ whiteSpace: 'nowrap' }}>
                                                            {Security.hasPermission('PERIODO_PRESUPUESTARIO_SUBREGIONES_VER') && (
                                                                <button
                                                                    className="btn btn-sm btn-icon btn-dt-grid text-success"
                                                                    title="Ver"
                                                                    onClick={() => this.setState({ redirectTo: this.props.match.url + '/' + subregion.id })}
                                                                >
                                                                    <i className="fa fa-search fa-xs"></i>
                                                                </button>
                                                            )}
                                                            {Security.hasPermission('PERIODO_PRESUPUESTARIO_SUBREGIONES_MODIFICAR') && (
                                                                <button
                                                                    className="btn btn-sm btn-icon btn-dt-grid text-success"
                                                                    title="Editar"
                                                                    onClick={() => this.setState({ redirectTo: this.props.match.url + '/' + subregion.id + '/edit' })}
                                                                >
                                                                    <i className="fa fa-pencil fa-xs"></i>
                                                                </button>
                                                            )}
                                                        </StyledTableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>

                                    <TablePagination
                                        rowsPerPageOptions={[10, 25, 50, 100]}
                                        component="div"
                                        count={filtered.length}
                                        rowsPerPage={rowsPerPage}
                                        page={page}
                                        onChangePage={(e, newPage) => this.setState({ page: newPage })}
                                        onChangeRowsPerPage={e => this.setState({ rowsPerPage: parseInt(e.target.value, 10), page: 0 })}
                                        labelRowsPerPage={this.props.intl.formatMessage({ id: 'periodoPresupuestario.pagination.rows_per_page', defaultMessage: 'Mostrar' })}
                                        labelDisplayedRows={function(p) { return this.props.intl.formatMessage({ id: 'periodoPresupuestario.pagination.displayed_rows', defaultMessage: 'Mostrando {from} a {to} de {count}' }, { from: p.from, to: p.to, count: p.count }) }.bind(this)}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </React.Fragment>
        )
    }
}

export default injectIntl(PeriodoPresupuestarioSubregiones)
